import { render } from "./ConfirmationTaskModel.vue?vue&type=template&id=980e62f6&scoped=true"
import script from "./ConfirmationTaskModel.vue?vue&type=script&lang=js"
export * from "./ConfirmationTaskModel.vue?vue&type=script&lang=js"

import "./ConfirmationTaskModel.vue?vue&type=style&index=0&id=980e62f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-980e62f6"

export default script